<template>
  <div id="app">
    <header v-if="ifWidth">
      <!-- 头部内容 -->
      <headIn :nowData="nowData" />
    </header>
    <main class="main-content">
      <router-view />
    </main>
    <footer v-if="ifWidth">
      <!-- 底部内容 -->
      <bottomIn :nowBottom="nowBottom" />
    </footer>
  </div>
</template>

<script>
import headIn from "./components/HeadComponent.vue";
import bottomIn from "./components/bottom.vue";
import method from "@/utils/Untitl.js";
import { showBrowserPrompt } from "./utils/wechat.js";
export default {
  components: {
    headIn,
    bottomIn,
  },
  data() {
    return {
      nowBottom: [],
      nowData: [],
      ifWidth: true,
    };
  },
  mounted() {
    this.getBottom();
    if (this.$route.path !== "/isWechat") {
      if (showBrowserPrompt()) {
        this.$router.push("/isWechat");
        this.ifWidth = false;
      } 
    }
  },
  methods: {
    async getBottom() {
      const res = await method.base_info();
      console.log(res);
      if (res.code == 1) {
        this.nowBottom = res.data;
        this.nowData = res.data;
      }
    },
  },
};
</script>

<style>
a {
  text-decoration: none;
}

* {
  margin: 0;
  padding: 0;
  transition: all 300ms ease;
}
ul {
  list-style: none;
}
li {
  list-style: none;
}
i {
  font-style: normal;
}
body {
  font: 16px/1.6 "Microsoft Yahei", "Thmano", "Arial";
  color: #3d3d3d;
}
.clearfix::after {
  content: "";
  display: table;
  clear: both;
}
.main-content {
  min-height: calc(100vh - 345.59px);
}
</style>